import { Tooltip } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { type ReactNode } from 'react';

interface ModalErrorProps {
    error?: ReactNode;
}

export const ModalError = ({ error }: ModalErrorProps) => {
    if (!error) {
        return null;
    }

    return (
        <Tooltip label={error}>
            <IconAlertTriangle size={16} color="red" />
        </Tooltip>
    );
};
